var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_tel",
    d: "M-61.051-51.414a25.03,25.03,0,0,0-25,25,25.031,25.031,0,0,0,25,25,25.031,25.031,0,0,0,25-25,25.031,25.031,0,0,0-25-25Zm15.513,37.053c-.67,2.232-3.683,5.468-6.473,5.468L-52.234-9c-4.129-.223-9.821-4.129-15.066-10.491l-1.9-2.344c-5.245-6.362-8.035-12.611-7.366-16.629.447-2.9,4.687-5.245,7.143-5.245,1.228,0,1.674.558,1.786,1,1.339,2.455,3.125,6.7,3.125,8.259v.223a3.518,3.518,0,0,1-1.562,1.562c-.781.447-1.228.781-1.339,1.562,0,.223.223,1.451,3.683,5.692l1.451,1.786c3.46,4.129,4.576,4.576,4.8,4.576.893.112,1.228-.223,1.9-.893A2.913,2.913,0,0,1-53.8-21.169h.223c1.562.335,5.357,2.79,7.589,4.687.335.112.893.67.447,2.12Z",
    transform: "translate(86.05 51.414)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTel);
export default __webpack_public_path__ + "static/media/ico_tel.5ad8d1c29c389fac8934ae190095828d.svg";
export { ForwardRef as ReactComponent };